(() => {
  class BekUnifiedCarportConfigurator {
    constructor(root) {
      this.root = root;
      this.step = 1;
      this.currentConfigId = null;
      this.measurementsTouched = false;
      this.locale = 'de-DE';
      this.currency = 'EUR';
      this.orderBridgeEnabled = root.dataset.orderBridgeEnabled === 'true';
      this.orderBridgeEndpoint = (root.dataset.orderBridgeEndpoint || '').trim();
      this.orderButtonLabel = root.dataset.orderButtonLabel || 'Jetzt sicher bestellen';
      const Engine = window.BEKProductEngine;
      const data = window.BEK_PRODUCT_DATA;
      if (!Engine || !data) {
        this.status('Preisengine konnte nicht geladen werden.', 'error');
        return;
      }
      this.engine = new Engine(data, {
        vatPct: Number(root.dataset.vatPct || 19),
        roundingMode: root.dataset.roundingMode || 'x090',
        priceMode: root.dataset.tdsPriceMode || 'vd_list_round90',
        dealerDiscountPct: Number(root.dataset.tdsDealerDiscountPct || 50),
        targetMarginPct: Number(root.dataset.tdsTargetMarginPct || 41),
        flatlinePriceMode: root.dataset.flatlinePriceMode || 'vd_list_round90',
        flatlineDealerDiscountPct: Number(root.dataset.flatlineDealerDiscountPct || 50),
        flatlineTargetMarginPct: Number(root.dataset.flatlineTargetMarginPct || 40),
        mountingDealerDiscountPct: Number(root.dataset.mountingDealerDiscountPct || 50),
        mountingSurcharge6000: Number(root.dataset.mountingSurcharge6000 || 1290),
        mountingSurcharge7000: Number(root.dataset.mountingSurcharge7000 || 1490),
        mountingSurcharge8000: Number(root.dataset.mountingSurcharge8000 || 1690),
        mountingSurcharge9000: Number(root.dataset.mountingSurcharge9000 || 1790),
        mountingSurcharge10000: Number(root.dataset.mountingSurcharge10000 || 1890),
        mountingSurcharge11000: Number(root.dataset.mountingSurcharge11000 || 1990),
        mountingSurcharge12000: Number(root.dataset.mountingSurcharge12000 || 2090),
        mountingCombo6000: Number(root.dataset.mountingCombo6000 || 2490),
        mountingComboDiscountPctAbove6: Number(root.dataset.mountingComboDiscountPctAbove6 || 0),
        ledDealerDiscountPct: Number(root.dataset.ledDealerDiscountPct || 0),
        ledGross6: Number(root.dataset.ledGross6 || 149),
        ledGross8: Number(root.dataset.ledGross8 || 179),
        ledGross6wifi: Number(root.dataset.ledGross6wifi || 179),
        ledGross12wifi: Number(root.dataset.ledGross12wifi || 269),
        staticsDealerDiscountPct: Number(root.dataset.staticsDealerDiscountPct || 0),
        staticsGrossCalculation: Number(root.dataset.staticsGrossCalculation || 249),
        staticsGrossStamp: Number(root.dataset.staticsGrossStamp || 990)
      });
      this.bind();
      this.applySystemFromUrl();
      this.syncSystemUi(true);
      this.update();
      this.showStep(1, false);
    }

    q(s) { return this.root.querySelector(s); }
    qa(s) { return [...this.root.querySelectorAll(s)]; }
    checked(name) { return this.q(`[name="${name}"]:checked`)?.value || ''; }
    val(name) { return this.q(`[name="${name}"]`)?.value || ''; }
    money(n) { return new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency, maximumFractionDigits: 0 }).format(Number(n || 0)); }
    mm(n) { return new Intl.NumberFormat(this.locale).format(Number(n || 0)) + ' mm'; }
    set(selector, value) { this.qa(selector).forEach((el) => { el.textContent = value; }); }
    show(selector, visible) { this.qa(selector).forEach((el) => { el.hidden = !visible; }); }

    system() { return (this.checked('cp_system') || 'FLATLINE').toUpperCase(); }
    isTds() { return this.system() === 'TDS_CARPORT'; }
    productName() { return this.isTds() ? 'TDS Carport' : 'Flat Line Carport'; }

    rules() {
      return this.isTds()
        ? { width: { min: 2000, max: 12000 }, depth: { min: 1500, max: 4500 } }
        : { width: { min: 3000, max: 14000 }, depth: { min: 2000, max: 7000 } };
    }

    applySystemFromUrl() {
      try {
        const p = new URLSearchParams(location.search).get('system');
        const target = String(p || '').toUpperCase();
        if (['TDS_CARPORT', 'TDS-CARPORT', 'TDS'].includes(target)) {
          const el = this.q('[name="cp_system"][value="TDS_CARPORT"]'); if (el) el.checked = true;
          const w = this.q('[name="cp_width"]'); const d = this.q('[name="cp_depth"]'); if (w) w.value = '6000'; if (d) d.value = '4000';
        } else if (['FLATLINE', 'FLAT_LINE'].includes(target)) {
          const el = this.q('[name="cp_system"][value="FLATLINE"]'); if (el) el.checked = true;
        }
      } catch (_) {}
    }

    bind() {
      this.root.addEventListener('input', (e) => {
        if (e.target.matches('[name="cp_width"], [name="cp_depth"]')) this.measurementsTouched = true;
        if (e.target.matches('input')) this.update();
      });
      this.root.addEventListener('change', (e) => {
        if (!e.target.matches('input')) return;
        if (e.target.matches('[name="cp_system"]')) {
          this.currentConfigId = null;
          if (!this.measurementsTouched) {
            const w = this.q('[name="cp_width"]'); const d = this.q('[name="cp_depth"]');
            if (this.isTds()) { if (w) w.value = '6000'; if (d) d.value = '4000'; }
            else { if (w) w.value = '6000'; if (d) d.value = '3500'; }
          }
          this.syncSystemUi(false);
        }
        if (e.target.matches('[name="cp_tds_mounting_combo"]') && e.target.checked) {
          const free = this.q('[name="cp_tds_mounting"][value="freestanding"]'); if (free) free.checked = true;
        } else if (e.target.matches('[name="cp_tds_mounting"]')) {
          const combo = this.q('[name="cp_tds_mounting_combo"]'); if (combo && e.target.value !== 'freestanding') combo.checked = false;
        }
        this.syncChoiceClasses();
        this.update();
      });
      this.qa('[data-cp-next]').forEach((b) => b.addEventListener('click', () => {
        if (this.step === 1 && !this.validateMeasurements(true)) return;
        this.showStep(Math.min(6, this.step + 1));
      }));
      this.qa('[data-cp-back]').forEach((b) => b.addEventListener('click', () => this.showStep(Math.max(1, this.step - 1))));
      this.qa('[data-cp-jump]').forEach((b) => b.addEventListener('click', () => {
        const n = Number(b.dataset.cpJump); if (n > 1 && !this.validateMeasurements(false)) return; this.showStep(n);
      }));
      this.q('[data-cp-order]')?.addEventListener('click', (e) => this.submit(e.currentTarget));
    }

    syncChoiceClasses() {
      this.qa('[data-cp-system-card]').forEach((card) => card.classList.toggle('is-selected', Boolean(card.querySelector('input:checked'))));
      this.qa('.bek-carport-choice').forEach((card) => card.classList.toggle('is-selected', Boolean(card.querySelector('input:checked'))));
    }

    syncSystemUi(initial = false) {
      const tds = this.isTds();
      const rules = this.rules();
      const width = this.q('[name="cp_width"]'); const depth = this.q('[name="cp_depth"]');
      if (width) { width.min = String(rules.width.min); width.max = String(rules.width.max); }
      if (depth) { depth.min = String(rules.depth.min); depth.max = String(rules.depth.max); }
      this.set('[data-cp-width-help]', `${this.mm(rules.width.min).replace(' mm','')}–${this.mm(rules.width.max)}`);
      this.set('[data-cp-depth-help]', `${this.mm(rules.depth.min).replace(' mm','')}–${this.mm(rules.depth.max)}`);
      this.set('[data-cp-measure-title]', tds ? 'TDS Carport Maßbereich' : 'Flat Line Maßbereich');
      this.set('[data-cp-measure-note]', tds
        ? 'Identisch zum bestehenden TDS-System: Ihr Maß wird der passenden TDS-Produktionsgröße zugeordnet.'
        : 'Ihr Wunschmaß wird automatisch der passenden Flat-Line-Produktionsgröße zugeordnet.');
      this.show('[data-cp-preview="FLATLINE"]', !tds); this.show('[data-cp-preview="TDS_CARPORT"]', tds);
      this.set('[data-cp-preview-title]', this.productName());
      this.set('[data-cp-preview-subtitle]', tds ? 'Wandmontage · freistehend · Dachüberstand' : 'Freistehend · kubische Optik');
      this.show('[data-cp-flat-mounting]', !tds); this.show('[data-cp-tds-mounting]', tds);
      this.show('[data-cp-flat-options]', !tds); this.show('[data-cp-tds-options]', tds);
      this.show('[data-cp-tds-equipment]', tds); this.show('[data-cp-sum-led-row]', tds);
      this.set('[data-cp-mounting-intro]', tds
        ? 'Beim TDS Carport stehen dieselben Montagearten wie beim TDS Überdachungssystem zur Verfügung.'
        : 'Flat Line wird als freistehendes Carportsystem mit Pfosten vorne und hinten geplant.');
      this.syncChoiceClasses();
      if (!initial) this.validateMeasurements(false);
    }

    validateMeasurements(focus = false) {
      const r = this.rules(); const w = Number(this.val('cp_width')); const d = Number(this.val('cp_depth'));
      const ok = Number.isFinite(w) && Number.isFinite(d) && w >= r.width.min && w <= r.width.max && d >= r.depth.min && d <= r.depth.max;
      const warning = this.q('[data-cp-measure-error]'); if (warning) warning.hidden = ok;
      if (!ok && focus) this.q('[name="cp_width"]')?.focus({ preventScroll: true });
      return ok;
    }

    showStep(n, scroll = true) {
      this.step = Math.max(1, Math.min(6, Number(n || 1)));
      this.qa('[data-cp-step]').forEach((s) => { const active = Number(s.dataset.cpStep) === this.step; s.hidden = !active; s.classList.toggle('is-active', active); });
      this.qa('[data-cp-jump]').forEach((b) => b.classList.toggle('is-active', Number(b.dataset.cpJump) === this.step));
      if (scroll) this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    staticsQuote() { return this.engine.calculateEquipmentOption({ category: 'statics', value: this.checked('cp_statics') || 'simple' }); }
    ledQuote() { return this.engine.calculateEquipmentOption({ category: 'led', value: this.checked('cp_led') || 'none' }); }
    mountingQuote(width) {
      if (!this.isTds()) return { ok: true, mode: 'freestanding', label: 'Freistehend', combo: false, customerGrossSurcharge: 0, quantity: { posts: 0 }, flags: [] };
      const mode = this.checked('cp_tds_mounting') || 'wall'; const combo = Boolean(this.q('[name="cp_tds_mounting_combo"]')?.checked);
      return this.engine.calculateMountingConstruction({ width, mode, combo });
    }

    quote() {
      const width = Number(this.val('cp_width')); const depth = Number(this.val('cp_depth')); const statics = this.staticsQuote();
      if (this.isTds()) {
        const cover = this.checked('cp_tds_cover') || 'clear';
        const base = this.engine.calculateTds({ width, depth, glass: cover });
        const mounting = this.mountingQuote(width); const led = this.ledQuote();
        const total = base?.ok && mounting?.ok ? Number(base.customerGross || 0) + Number(mounting.customerGrossSurcharge || 0) + Number(led?.customerGrossSurcharge || 0) + Number(statics?.customerGrossSurcharge || 0) : 0;
        return { base, mounting, led, statics, total };
      }
      const cover = this.checked('cp_flat_cover') || 'standard';
      const base = this.engine.calculateFlatLine({ width, depth, cover });
      const total = base?.ok ? Number(base.customerGross || 0) + Number(statics?.customerGrossSurcharge || 0) : 0;
      return { base, mounting: this.mountingQuote(width), led: null, statics, total };
    }

    blocking(q) {
      if (!q?.base?.ok) return [{ code: 'BASE_NOT_PRICEABLE', message: 'Für diese Maße konnte kein gültiger Matrixpreis ermittelt werden.' }];
      if (this.isTds()) {
        if (!q.mounting?.ok) return [{ code: 'MOUNTING_NOT_PRICEABLE', message: 'Die gewählte TDS-Montageart konnte nicht berechnet werden.' }];
        return [];
      }
      return (q.base.flags || []).filter((f) => ['FLATLINE_RAFTER_CORE_REQUIRED_NOT_PRICED', 'FLATLINE_GUTTER_CORE_REQUIRED_NOT_PRICED'].includes(f.code));
    }

    mountingLabel() {
      if (!this.isTds()) return 'Freistehend';
      const combo = Boolean(this.q('[name="cp_tds_mounting_combo"]')?.checked); if (combo) return 'Freistehend + Dachüberstand';
      return ({ wall: 'Wandmontage', freestanding: 'Freistehend', overhang: 'Freitragend mit Dachüberstand' })[this.checked('cp_tds_mounting') || 'wall'];
    }
    coverLabel(q) {
      if (this.isTds()) return q?.base?.glassLabel || ({ clear:'VSG 8 mm klar', matt:'VSG 8 mm matt', poly_clear:'Polycarbonat klar', poly_opal:'Polycarbonat opal', poly_graphite:'Polycarbonat graphit', poly_bronze:'Polycarbonat bronze' })[this.checked('cp_tds_cover')] || 'Dachdeckung';
      return q?.base?.coverLabel || ({ excl:'Ohne Trapezblech', standard:'Trapezblech Standard', anti:'Trapezblech mit Antikondensvlies' })[this.checked('cp_flat_cover')] || 'Dachdeckung';
    }
    colorLabel() { return 'RAL ' + (this.isTds() ? (this.checked('cp_tds_color') || '7016') : (this.checked('cp_flat_color') || '7016')); }
    staticsLabel() { return ({ simple:'Vereinfachter Nachweis', calculation:'Individuelle Berechnung', stamp:'Statik mit Stempel' })[this.checked('cp_statics') || 'simple']; }
    ledLabel() { return ({ none:'Ohne LED', '6':'6 LED-Spots', '8':'8 LED-Spots', '6wifi':'6 LED + WiFi', '12wifi':'12 LED + WiFi' })[this.checked('cp_led') || 'none']; }

    renderOptionPrices(width) {
      if (this.isTds()) {
        ['freestanding','overhang'].forEach((mode) => {
          const q = this.engine.calculateMountingConstruction({ width, mode, combo: false });
          this.set(`[data-cp-mounting-price="${mode}"]`, q?.ok ? `+ ${this.money(q.customerGrossSurcharge)}` : 'Preis prüfen');
        });
        const combo = this.engine.calculateMountingConstruction({ width, mode: 'freestanding', combo: true });
        this.set('[data-cp-mounting-price="combo"]', combo?.ok ? `Gesamt + ${this.money(combo.customerGrossSurcharge)}` : 'Preis prüfen');
        const mt = this.q('[data-cp-mounting-tech]');
        if (mt && this.current?.mounting?.ok && this.current.mounting.customerGrossSurcharge > 0) {
          const qty = this.current.mounting.quantity || {};
          mt.textContent = `${qty.constructionRuns || 1} Zusatzkonstruktion${Number(qty.constructionRuns || 1) > 1 ? 'en' : ''} · ${qty.posts || 0} Zusatzpfosten · ${qty.beamPieces || 0} Statikträger-Teilstück${Number(qty.beamPieces || 0) === 1 ? '' : 'e'}.`;
        } else if (mt) mt.textContent = '';
      }
      ['none','6','8','6wifi','12wifi'].forEach((v) => { const q = this.engine.calculateEquipmentOption({ category:'led', value:v }); if (q?.ok) this.set(`[data-cp-led-price="${v}"]`, q.customerGrossSurcharge ? `+${this.money(q.customerGrossSurcharge)}` : 'inklusive'); });
      ['simple','calculation','stamp'].forEach((v) => { const q = this.engine.calculateEquipmentOption({ category:'statics', value:v }); if (q?.ok) this.set(`[data-cp-statics-price="${v}"]`, q.customerGrossSurcharge ? `+${this.money(q.customerGrossSurcharge)}` : 'inklusive'); });
    }

    update() {
      this.syncSystemUi(true);
      const width = Number(this.val('cp_width')); const depth = Number(this.val('cp_depth'));
      const q = this.quote(); this.current = q; this.renderOptionPrices(width);
      const system = this.productName(); const mounting = this.mountingLabel(); const cover = this.coverLabel(q); const color = this.colorLabel(); const statics = this.staticsLabel(); const led = this.ledLabel();
      this.set('[data-cp-sum-system],[data-cp-review-system]', system);
      this.set('[data-cp-sum-subtitle]', this.isTds() ? 'TDS-System als Carport · flexible Montagearten' : 'Freistehendes Aluminium-Carportsystem');
      this.set('[data-cp-sum-width]', this.mm(width)); this.set('[data-cp-sum-depth]', this.mm(depth));
      this.set('[data-cp-sum-mounting],[data-cp-review-mounting]', mounting);
      this.set('[data-cp-sum-cover],[data-cp-review-cover]', cover); this.set('[data-cp-sum-color],[data-cp-review-color]', color);
      this.set('[data-cp-sum-statics]', statics); this.set('[data-cp-sum-led]', led);
      this.set('[data-cp-review-dims]', `${this.mm(width)} × ${this.mm(depth)}`);
      this.set('[data-cp-review-equipment]', this.isTds() ? `${led} · ${statics}` : statics);
      const price = q?.base?.ok ? this.money(q.total) : 'Preis prüfen'; this.set('[data-cp-price],[data-cp-final-price]', price);
      if (this.isTds()) {
        this.set('[data-cp-structure]', q?.base?.ok ? `Preisstaffel ${this.mm(q.base.widthBand)} × ${this.mm(q.base.depthBand)} · ${mounting}` : '');
      } else {
        const b = q.base || {};
        this.set('[data-cp-structure]', b.ok ? `${b.rafterCount} Sparren · ${b.frontPostCount} Pfosten vorne · ${b.rearPostCount} hinten` : '');
      }
      const b = q.base || {};
      this.set('[data-cp-debug-band]', b.ok ? `${this.mm(b.widthBand)} × ${this.mm(b.depthBand)}` : '–');
      this.set('[data-cp-debug-list]', b.ok ? this.money(b.vdListNet) : '–'); this.set('[data-cp-debug-ek]', b.ok ? this.money(b.bekEkNet) : '–');
      this.set('[data-cp-debug-margin]', b.ok ? `${Number(b.rawMarginPct || 0).toFixed(1).replace('.',',')} %` : '–');
      const flags = this.blocking(q); const tech = this.q('[data-cp-tech]');
      if (tech) {
        tech.classList.toggle('is-blocked', flags.length > 0);
        tech.innerHTML = flags.length
          ? `<strong>Technische Prüfung erforderlich</strong><br>${flags.map((f) => f.message).join('<br>')}`
          : `<strong>Online-Konfiguration technisch freigegeben.</strong><br>${this.isTds() ? 'TDS-Grunddach und Montagekonstruktion werden aus den bestehenden BEK-TDS-Regeln berechnet.' : 'Flat-Line-Matrix ist für dieses Maß vollständig bepreist.'} Lieferung wird mit 0 € angesetzt.`;
      }
      const button = this.q('[data-cp-order]'); if (button) { button.disabled = !q?.base?.ok || flags.length > 0; button.textContent = flags.length ? 'Technische Prüfung erforderlich' : `${this.orderButtonLabel} →`; }
      this.currentConfigId = null;
    }

    configId() {
      if (this.currentConfigId) return this.currentConfigId;
      const d = new Date(); const date = `${d.getFullYear()}${String(d.getMonth()+1).padStart(2,'0')}${String(d.getDate()).padStart(2,'0')}`;
      let token = Math.random().toString(36).slice(2,10).toUpperCase();
      if (window.crypto?.getRandomValues) { const b = new Uint8Array(4); window.crypto.getRandomValues(b); token = Array.from(b, (x) => x.toString(36).padStart(2,'0')).join('').slice(0,8).toUpperCase(); }
      this.currentConfigId = `BEK-${this.isTds() ? 'TCP' : 'FLT'}-${date}-${token}`;
      return this.currentConfigId;
    }

    payload() {
      const width = Number(this.val('cp_width')); const depth = Number(this.val('cp_depth')); const q = this.current || this.quote();
      const common = {
        schemaVersion: 'BEK_CARPORT_ORDER_PAYLOAD_V2', engineVersion: 'M11.9.1-CARPORT-ENGINE', configurationId: this.configId(), generatedAt: new Date().toISOString(), currency:'EUR', locale:'de-DE',
        display: { product:this.productName(), totalGross:Number(q.total || 0), vatPct:Number(this.root.dataset.vatPct || 19), shippingIncluded:true, shippingGross:0, shippingLabel:'Kostenlose BEK Lieferung' },
        delivery: { schemaVersion:'BEK_DELIVERY_V1', countryCode:'DE', requestedMethod:'FREE_STANDARD', requestedFulfillment:'BEK_DELIVERY', clientShippingGross:0, clientShippingIsAdvisory:true },
        technicalReview: { required:this.blocking(q).length > 0, flags:this.blocking(q) },
        security: { clientPriceIsAdvisory:true, serverMustRecalculate:true, serverMustDetermineDelivery:true, noApiSecretsInPayload:true }
      };
      if (this.isTds()) {
        const mounting = this.checked('cp_tds_mounting') || 'wall'; const combo = Boolean(this.q('[name="cp_tds_mounting_combo"]')?.checked);
        return { ...common, product:{ code:'TDS_CARPORT', name:'TDS Carport', configurator:'CARPORT_UNIFIED' }, customerSelection:{ productCode:'TDS_CARPORT', widthMm:width, depthMm:depth, mounting, mountingCombo:combo, glass:this.checked('cp_tds_cover') || 'clear', color:`RAL ${this.checked('cp_tds_color') || '7016'}`, led:this.checked('cp_led') || 'none', statics:this.checked('cp_statics') || 'simple' }, display:{ ...common.display, mounting:this.mountingLabel(), cover:this.coverLabel(q), color:this.colorLabel(), led:this.ledLabel(), statics:this.staticsLabel() } };
      }
      const base = q.base || {};
      return { ...common, product:{ code:'FLATLINE', name:'Flat Line Carport', configurator:'CARPORT_UNIFIED' }, customerSelection:{ productCode:'FLATLINE', widthMm:width, depthMm:depth, mounting:'freestanding', cover:this.checked('cp_flat_cover') || 'standard', color:`RAL ${this.checked('cp_flat_color') || '7016'}`, statics:this.checked('cp_statics') || 'simple' }, display:{ ...common.display, mounting:'Freistehend', cover:this.coverLabel(q), color:this.colorLabel(), statics:this.staticsLabel(), structure:{ rafters:base.rafterCount || 0, supports:base.supportCount || 0, frontPosts:base.frontPostCount || 0, rearPosts:base.rearPostCount || 0 } } };
    }

    endpoint() {
      if (!this.orderBridgeEndpoint || !this.orderBridgeEndpoint.startsWith('/') || this.orderBridgeEndpoint.startsWith('//')) return null;
      try { const u = new URL(this.orderBridgeEndpoint, location.origin); return u.origin === location.origin ? u.href : null; } catch (_) { return null; }
    }
    status(msg, type='info') { const e = this.q('[data-cp-order-status]'); if (e) { e.textContent = msg; e.dataset.type = type; } }

    async submit(button) {
      const p = this.payload(); const q = this.current;
      if (!this.validateMeasurements(true) || !q?.base?.ok) { this.status('Bitte gültige Maße auswählen.', 'error'); return; }
      if (p.technicalReview.required) { this.status('Für diese Konfiguration ist vor dem Checkout eine technische Prüfung erforderlich.', 'error'); return; }
      if (!this.orderBridgeEnabled) { this.status('Die sichere Bestellfunktion ist derzeit nicht verfügbar. Bitte kontaktieren Sie BEK.', 'error'); return; }
      const endpoint = this.endpoint(); if (!endpoint) { this.status('Bestellbrücke ist nicht korrekt konfiguriert.', 'error'); return; }
      const old = button.textContent; button.disabled = true; button.textContent = 'Wird geprüft …'; this.status('Konfiguration wird serverseitig geprüft …');
      try {
        const r = await fetch(endpoint, { method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify(p) });
        const out = await r.json().catch(() => ({})); if (!r.ok) throw new Error(out.message || out.error || `HTTP ${r.status}`); if (!out.checkoutUrl) throw new Error('Checkout-URL fehlt.');
        this.status(`Serverpreis geprüft: ${this.money(out.serverGross || q.total)} · Lieferung kostenlos. Checkout wird geöffnet …`, 'success'); location.assign(new URL(out.checkoutUrl, location.origin).href);
      } catch (err) { button.disabled = false; button.textContent = old; this.status(`Bestellübergabe fehlgeschlagen: ${err.message}`, 'error'); }
    }
  }

  const init = () => document.querySelectorAll('[data-bek-carport-configurator]').forEach((root) => {
    if (!root.dataset.bekCarportInitialized) { root.dataset.bekCarportInitialized = '1'; new BekUnifiedCarportConfigurator(root); }
  });
  document.addEventListener('DOMContentLoaded', init); document.addEventListener('shopify:section:load', init);
})();
